import * as React from 'react';

import { IdentityContext } from './IdentityContext';

/**
 * Hook to check organization entitlements
 */
export function useEntitlements() {
  const context = React.useContext(IdentityContext);

  if (!context) {
    throw new Error('useEntitlements must be used within an IdentityProvider');
  }

  const { organization } = context;

  return React.useMemo(() => {
    const entitlements = organization?.entitlements || [];

    return {
      entitlements,
      hasEntitlement: (entitlement: string) =>
        entitlements.includes(entitlement),
      hasCustomerPortal: entitlements.includes('customerPortal'),
      hasExports: entitlements.includes('exports'),
    };
  }, [organization?.entitlements]);
}
